import { render, staticRenderFns } from "./newFormEditor.vue?vue&type=template&id=55be4221&"
import script from "./newFormEditor.vue?vue&type=script&lang=ts&"
export * from "./newFormEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports